// Add your custom JS here.

	(function ($) {
	  var lastScrollTop = 0,
	    delta = 90;
	  $(window).scroll(function () {
	    var nowScrollTop = $(this).scrollTop();
	    if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
	      if (nowScrollTop > lastScrollTop) {
	        $("#wrapper-navbar").addClass("scrolled-down");
	        $("#wrapper-navbar").removeClass("scrolled-up");
	      } else {
	        $("#wrapper-navbar").addClass("scrolled-up");
	        $("#wrapper-navbar").removeClass("scrolled-down");
	      }
	      lastScrollTop = nowScrollTop;
	    }
	  });
	  $(window).on("resize scroll", function () {
	    if ($(window).scrollTop() < 90) {
	      $("#wrapper-navbar").removeClass("scrolled-up");
	    }
	  });
	  $(document.body).on('click', ".wp-block-search", function (e) {
	    var $this = $(this);
	    var $search_block = $this.closest('.wp-block-search');
	    if (e.target == this) {
	      console.log('clicked on parent element');
	      $search_block.hasClass('active') ? $search_block.removeClass('active') : $search_block.addClass('active');
	    }
	  });
	  $(document.body).on('click', function (e) {
	    var $parent = $('.wp-block-search');
	    if (!$parent.is(e.target) && $parent.has(e.target).length === 0) {
	      $parent.removeClass('active');
	    }
	  });


	   /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
        $('.case-study__carousel').each(function(){
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() < 1199) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        dots: false,
					    infinite: false,
					    slidesToShow: 1,
					    variableWidth: true,
					    arrows: false,

                    });
                }
            }
        });
    });


	  $('.news__carousel').slick({
	    dots: false,
	    infinite: false,
	    slidesToShow: 2,
	    slidesToScroll: 1,
	    variableWidth: true,
	    arrows: true,
	    responsive: [{
	      breakpoint: 992,
	      settings: {
	        infinite: false,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        variableWidth: true,
	        dots: true,
	        arrows: true
	      }
	    }]
	  });

	  $('.carousel-reviews').slick({
	    dots: true,
	    infinite: false,
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    variableWidth: true,
	    arrows: true,
	  });

	  $('.single-carousel').slick({
	    dots: true,
	    infinite: true,
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    variableWidth: false,
	    arrows: true,
	  });

	 	   /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
        $('.sectors .is-layout-grid').each(function(){
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() < 1199) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        dots: false,
					    infinite: true,
					    slidesToShow: 2,
					    slidesToScroll: 1,
					    variableWidth: true,

					    nextArrow: '.carousel-next',
				  		prevArrow: '.carousel-prev'

                    });
                }
            }
        });
    });





	  $('.sectors-carousel .is-layout-grid').slick({
	    dots: false,
	    infinite: true,
	    slidesToShow: 2,
	    slidesToScroll: 1,
	    variableWidth: true,
	    arrows: true,
	  });

	 $('.carousel-home').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true
            }
        }]
    })





	})(jQuery);